import type { RoleplayDebrief } from '@wundo/shared/roleplay.ts';
import { PracticeDebrief } from './PracticeDebrief.tsx';
import { m } from '@/paraglide/messages.js';

export interface PracticeSessionFeedbackProps {
  /** Null when nobody spoke: there is nothing to give feedback on. */
  debrief: RoleplayDebrief | null;
}

/**
 * What one finished practice conversation left behind.
 *
 * Two places read it: the dialog on Oefenen, and the dedicated address someone
 * who came in on a link ends up on. They frame it differently — a dialog header
 * with a cross, a card under the logo — but what is inside the frame is one
 * thing, so a conversation that produced nothing says so in the same words
 * wherever it is read.
 */
export function PracticeSessionFeedback({ debrief }: PracticeSessionFeedbackProps) {
  if (debrief === null) {
    return (
      <p className='text-base text-ink-muted'>{m.practice_session_aborted_body()}</p>
    );
  }

  return <PracticeDebrief debrief={debrief} />;
}
